import WorkbenchInterface from '../common/WorkbenchInterface'
import { getAttributes } from '../common/attributeTransformation'
import transformAttributes from '@/components/common/attributes'
import XandrAPI from '@/api/XandrAPI'
import { saveTarget, fetchSingleTarget } from '@/api'
import { getCurrentDate, addDaysToDate, addMonthsToDate } from '@/common/U_D'
import { getAllDatasetsRootFamilyFromQuery } from '@/common/U'
import {
  ACTIVATION_STATUS,
  TARGET_TYPE,
  TARGET_TYPES_INTEGERS,
  DESTINATIONS,
  VIEWING_STREAMS,
} from '@/appLogic/targets/Constants'

import {
  STORE_NAME,
  SEND_DOWN_STREAM,
  SET_ENABLE_UPDATE_INSIGHTS,
  SET_LOADING_INSIGHTS,
  SET_QUERY,
  RESET,
  SET_ENABLE_UPDATE_TARGET_HEADER_DATA,
  SET_INTERFACE,
  SHOW_SAVING_LIVE_DIGITAL_PROMPT,
  SET_CONTROL_URL,
  SET_QUERY_ERRORED_OUT,
  CONFIGURE_AUDIENCE_EXPANSION,
} from './store/actions'

import {
  SET_TARGET,
  SET_LOADING_WORKBENCH,
  SET_SLOTTED_VALUE,
  SET_ENABLE_SAVE_BUTTON,
  SAVE_TARGET,
  SET_ENABLE_DOWN_STREAM,
  SET_ENABLE_DEFINITION_ACTIONS,
  SET_ATTRIBUTES,
  NOTIFY_ADCITY,
} from '../common/store/actions'
import XandrStore from './store'
import router from '@/router'
import Toast from '@/components/common/toasts'
import { cloneDeep } from 'lodash'
import { SET_VIEW_ONLY } from '@/appComponents/workbench/targetDefinition/store/actions'

const RESPONSE_TIME = 300
const DIGITAL_DESTINATIONS = [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER]



class XandrInterface extends WorkbenchInterface {
  setInterface(context) {
    context.dispatch(SET_INTERFACE, this)
  }

  /**
   * @param {Target} target - this is the target that will be saved
   */
  saveTarget(targetInfo) {
    let target = targetInfo.target
    let newTarget = !target.id
    const query = targetInfo.targetDefinition
    target.target_definition = { query: query }
    target.target =
      targetInfo.target.target &&
      (targetInfo.target.target === TARGET_TYPE.XANDR_SEGMENT || targetInfo.target.target === TARGET_TYPE.ADSTRA)
        ? targetInfo.target.target
        : TARGET_TYPE.ADSTRA
    target.target_type =
      targetInfo.target.target_type &&
      (targetInfo.target.target_type === TARGET_TYPES_INTEGERS.XANDR_SEGMENT_ADVERTISING ||
        targetInfo.target.target_type === TARGET_TYPES_INTEGERS.ADSTRA)
        ? targetInfo.target.target_type
        : TARGET_TYPES_INTEGERS.ADSTRA
    const activationStatusesToOverwrite = [ACTIVATION_STATUS.FAILED]
    target.activation_status = activationStatusesToOverwrite.includes(target.activation_status)
      ? ACTIVATION_STATUS.WORKING
      : target.activation_status
    if (target.xandr_data) {
      target.xandr_data.query = targetInfo.context.getters.xandrQuery
      target.xandr_data.audienceExpansion = targetInfo.context.getters.audienceExpansion
    } else {
      target.xandr_data = {
        addressable: false,
        audienceExpansion: targetInfo.context.getters.audienceExpansion,
      }
    }
    if (!target.am_data) {
      target.am_data = {
        flightStartDate: null,
        flightEndDate: null,
        status: null,
        xdFlightOverlap: 0,
      }
    }
    if (target.viewing_stream !== VIEWING_STREAMS.LSD) {
      target.viewing_stream = VIEWING_STREAMS.LSD
    }
    let context = targetInfo.context
    // TODO we will need the actual target type for the segment
    let tAndTd = super.getTargetAndDatasourceInformation(query)
    target = { ...target, ...tAndTd }
    context.dispatch(SET_LOADING_WORKBENCH, true)
    context.dispatch(SET_ENABLE_UPDATE_INSIGHTS, false)
    context.dispatch(SET_ENABLE_DEFINITION_ACTIONS, false)
    return saveTarget(target)
      .then(resp => {
        if (resp && resp.data) {
          context.commit(SET_TARGET, resp.data)
          context.dispatch(SET_LOADING_WORKBENCH, false)
          if (newTarget) {
            router.push({ name: 'XandrWorkbench', params: { id: resp.data.id } })
          }
        }
        if (resp && resp.data && resp.data.activation_status !== ACTIVATION_STATUS.DRAFT) {
          if (!targetInfo.ignoreSavePrompt) {
            let isLive = target.activation_status === ACTIVATION_STATUS.LIVE
            let isLiveDigitalTarget =
              isLive &&
              target.destinations.some(destination => [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination))
            if (isLiveDigitalTarget) {
              context.dispatch(SHOW_SAVING_LIVE_DIGITAL_PROMPT)
            }
          }
          Toast.success({
            title: 'Save Succeeded',
            message: 'Target has been saved',
          })
          context.commit(SET_ENABLE_SAVE_BUTTON, false)
          context.commit(SET_ENABLE_DOWN_STREAM, false)
        } else if (resp && resp.data && resp.data.activation_status === ACTIVATION_STATUS.DRAFT) {
          context.commit(SET_ENABLE_DOWN_STREAM, false)
        }
        context.commit(SET_ENABLE_UPDATE_TARGET_HEADER_DATA, false)
      })
      .catch(err => {
        context.dispatch(SET_LOADING_WORKBENCH, false)
        console.log('save failed', err)
        Toast.error({
          title: 'Save Target Error',
          message: 'Save has failed, please refresh and try again',
          timeout: 15000,
        })
      })
      .finally(fin => {
        context.dispatch(SET_ENABLE_DEFINITION_ACTIONS, true)
      })
  }

  onTargetDefinitionChange(info) {
    info.context.dispatch(SET_ENABLE_UPDATE_INSIGHTS, true)
    info.context.dispatch(SET_ENABLE_SAVE_BUTTON, false)
    info.context.dispatch(SET_ENABLE_DOWN_STREAM, false)

    // Get the current target definition from the context
    const targetDefinition = info.context.getters.serializedDefinition

    // Configure audience expansion using the new store action
    const result = info.context.dispatch(CONFIGURE_AUDIENCE_EXPANSION, targetDefinition)

    return new Promise((resolve) => {
      resolve(result)
    })
  }

  getTargetDefinition(getters) {
    return getters.serializedDefinition
  }

  getAttributes(context) {
    return XandrAPI.getSegmentationTraits('Adstra').then(traits => {
      let transformedAttributes = transformAttributes(traits, traits.id, false)
      return transformedAttributes
    })
  }

  submitDownstream(targetInfo) {
    let context = targetInfo.context
    context.commit(SET_TARGET, targetInfo.target)
  }

  queryForData(targetInfo) {
    let dis = targetInfo.context.dispatch
    dis(SET_QUERY_ERRORED_OUT, false)
    dis(SET_LOADING_INSIGHTS, true)
    dis(SET_ENABLE_UPDATE_INSIGHTS, false)
    dis(SET_ENABLE_SAVE_BUTTON, false)
    targetInfo.xandrType = 'advertising' // defaults to Advertising for now...
    targetInfo.user = targetInfo.context.rootGetters.username
    targetInfo.audienceExpansion = targetInfo.context.getters.audienceExpansion
    dis(SET_ENABLE_DEFINITION_ACTIONS, false)
    return QueryAPI(targetInfo, targetInfo.context.getters.xandrUseMockData)
      .then(resp => {
        dis(SET_QUERY, resp)
        dis(SET_ENABLE_SAVE_BUTTON, true)
        return { slottedValue: resp }
      })
      .catch(ex => {
        dis(SET_ENABLE_UPDATE_INSIGHTS, true)
        dis(SET_QUERY_ERRORED_OUT, true)
        dis(SET_QUERY, {})
        return { slottedValue: {} }
      })
      .finally(fin => {
        dis(SET_LOADING_INSIGHTS, false)
        dis(SET_ENABLE_DOWN_STREAM, false)
        dis(SET_ENABLE_DEFINITION_ACTIONS, true)
      })
  }

  sendDownStream({ context, targetId }) {
    Toast.destroy()
    let copiedTarget = cloneDeep(context.state.workbenchTarget)
    const C360Datasources = context.rootGetters.getC360Datasources
    if (copiedTarget.am_data.flightStartDate) {
      console.log('user set flight start date')
      context.dispatch(SAVE_TARGET, { target: copiedTarget, ignoreSavePrompt: true }).then(resp => {
        context.dispatch(SEND_DOWN_STREAM)
      })
      return
    }
    if (
      copiedTarget.destinations.find(destination =>
        [
          DESTINATIONS.SYMPHONY,
          DESTINATIONS.DIRECTV,
          DESTINATIONS.VIZIO,
          DESTINATIONS.CANOE_LINEAR,
          DESTINATIONS.CANOE_VOD,
          DESTINATIONS.FREEWHEEL,
          DESTINATIONS.GOOGLE_AD_MANAGER,
          DESTINATIONS.FREEWHEEL_AUDIENCE_MANAGER,
          DESTINATIONS.VIDEOAMP
        ].includes(destination),
      ) &&
      (copiedTarget.activation_status === ACTIVATION_STATUS.WORKING ||
        copiedTarget.activation_status === ACTIVATION_STATUS.DRAFT ||
        copiedTarget.am_data.flightEndDate === null)
    ) {
      let currentDate = getCurrentDate()
      copiedTarget.am_data.flightStartDate = currentDate.toISOString()
      copiedTarget.am_data.AEFlightStartDate = addDaysToDate(currentDate, 2).toISOString() // 2 days
      let datasetsFromRootFamily = copiedTarget.target_definition.query
        ? getAllDatasetsRootFamilyFromQuery(copiedTarget.target_definition.query)
        : []
      if (
        [C360Datasources.EPSILON, C360Datasources.DCR, C360Datasources.VIDEOAMP, C360Datasources.LIVERAMP].some(d =>
          datasetsFromRootFamily.includes(d),
        ) &&
        copiedTarget.destinations.includes(DESTINATIONS.FREEWHEEL)
      ) {
        copiedTarget.am_data.flightEndDate = addMonthsToDate(currentDate, 6).toISOString() // 6 months
        copiedTarget.am_data.AEFlightEndDate = addMonthsToDate(currentDate, 6).toISOString() // 6 months
      } else if (
        copiedTarget.destinations.some(d => [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER].includes(d))
      ) {
        copiedTarget.am_data.flightEndDate = addMonthsToDate(currentDate, 24).toISOString() // 24 months
        copiedTarget.am_data.AEFlightEndDate = addMonthsToDate(currentDate, 24).toISOString() // 24 months
      } else {
        copiedTarget.am_data.flightEndDate = addDaysToDate(currentDate, 98).toISOString() // 14 weeks
        copiedTarget.am_data.AEFlightEndDate = addDaysToDate(currentDate, 98).toISOString() // 14 weeks
      }
    }
    context.dispatch(SAVE_TARGET, { target: copiedTarget, ignoreSavePrompt: true }).then(resp => {
      context.dispatch(SEND_DOWN_STREAM)
    })
  }

  /**
   * @param {UUID} targetId  - the targetId of the target sent Downstream
   * @param {VueX context} context - this is the context from the VueX action
   */
  __sendDownStream(info) {
    info.context.commit(SET_ENABLE_UPDATE_INSIGHTS, false)
    info.context.commit(SET_ENABLE_DOWN_STREAM, false)
    info.context.commit(SET_ENABLE_SAVE_BUTTON, false)
    info.context.dispatch(SET_LOADING_WORKBENCH, true)
    return XandrAPI.sendDownStream({
      targetId: info.targetId,
      user: info.context.rootGetters.username,
      type: 'advertising',
    })
      .then(resp => {
        Toast.success({
          title: 'Successfully Sent Downstream',
          message: `Target has been sent Downstream`,
          timeout: 100 * 1000,
        })
        info.context.commit(SET_TARGET, resp)
        info.context.dispatch(NOTIFY_ADCITY, info.targetId)
        info.context.commit(SET_ENABLE_UPDATE_TARGET_HEADER_DATA, false)
        info.context.dispatch(SET_LOADING_WORKBENCH, false)
        if (resp.activation_status === ACTIVATION_STATUS.LIVE) {
          info.context.commit(SET_VIEW_ONLY, true)
        }
      })
      .catch(async resp => {
        const targetInfo = await fetchSingleTarget({ target_id: info.targetId })
        // need to override activation_status property in case failed status has not updated before error returns
        info.context.commit(SET_TARGET, { ...targetInfo.data, activation_status: ACTIVATION_STATUS.FAILED })
        Toast.error({
          title: 'Error sending target Downstream',
          message: `The Target failed to send downstream, a developer has recieved information and will resolve the issue momentarily`,
          timeout: 100 * 1000,
        })
        info.context.commit(SET_ENABLE_SAVE_BUTTON, true)
        info.context.commit(SET_ENABLE_UPDATE_INSIGHTS, true)
        info.context.commit(SET_ENABLE_DOWN_STREAM, true)
        info.context.dispatch(SET_LOADING_WORKBENCH, false)
      })
  }

  onSetTarget(targetInfo, context) {
    let query = targetInfo.xandr_data.query
    context.dispatch(SET_QUERY, query)
    context.commit(SET_SLOTTED_VALUE, query)
    context.dispatch(SET_ENABLE_SAVE_BUTTON, false)

    if (query) {
      let s = targetInfo.activation_status
      let setDownStream =
        (s !== ACTIVATION_STATUS.SUBMITTED && s !== ACTIVATION_STATUS.LIVE && s !== ACTIVATION_STATUS.FAILED) ||
        (s === ACTIVATION_STATUS.LIVE &&
          targetInfo.destinations.some(destination =>
            [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination),
          ) &&
          targetInfo.activation_date !== targetInfo.last_update) ||
        (s === ACTIVATION_STATUS.FAILED && targetInfo.xandr_data && targetInfo.xandr_data.addressable) ||
        (s === ACTIVATION_STATUS.FAILED &&
          targetInfo.destinations.some(destination => DIGITAL_DESTINATIONS.includes(destination)))
      context.dispatch(SET_ENABLE_DEFINITION_ACTIONS, setDownStream)
      let targetIsInDraft = s === ACTIVATION_STATUS.DRAFT
      context.dispatch(SET_ENABLE_DOWN_STREAM, setDownStream && !targetIsInDraft)
    }
  }

  reset(context) {
    context.dispatch(RESET)
  }

  getStoreModules() {
    return [
      {
        name: STORE_NAME,
        module: XandrStore,
      },
    ]
  }

  getDefaultTarget() {
    return {}
  }

  onDuplicate(context) {
    context.dispatch(SET_ENABLE_UPDATE_INSIGHTS, true)
  }

  onCreate(context) {
    let t = context.getters.newWorkbenchTarget
    if (t.activation_status === ACTIVATION_STATUS.FAILED) {
      context.dispatch(SET_ENABLE_UPDATE_INSIGHTS, true)
      context.dispatch(SET_ENABLE_DOWN_STREAM, true)
    }
    context.dispatch(SET_CONTROL_URL)
  }

  modelLAL(context) {
    context.commit(SET_ENABLE_SAVE_BUTTON, false)
    context.commit(SET_LOADING_WORKBENCH, true)
    return XandrAPI.modelLAL({ target: { targetId: context.state.workbenchTarget.id } })
      .then(resp => {
        if (resp.status && resp.status === 'failed' && resp.message) {
          Toast.error({
            title: 'LAL Modeling Failed',
            message: 'An unexpected error occurred during the LAL modeling process.',
            timeout: 10000,
            class: 'wrap-toast',
          })
          // Throw error to trigger catch block in component
          throw new Error('LAL Modeling Failed')
        } else {
          // Success case - update target data and show success notification
          context.commit(SET_TARGET, resp)
          Toast.success({
            title: 'LAL Modeling Successful',
            message: 'LAL modeling has been completed successfully.',
            timeout: 5000,
          })
          context.commit(SET_LOADING_WORKBENCH, false)
          return resp
        }
      })
      .catch(error => {
        // Handle network errors or other API failures
        Toast.error({
          title: 'LAL Modeling Failed',
          message: 'An unexpected error occurred during the LAL modeling process.',
          timeout: 10000,
          class: 'wrap-toast',
        })
        context.commit(SET_LOADING_WORKBENCH, false)
        throw error // Re-throw to allow component to handle
      })
  }

  onSetAdvertiser(context) {
    // let t = context.rootState.workbench.xandr_workbench.traits
    // if (t) {
    // context.commit(SET_ATTRIBUTES, {data: t, flat: {name: t.name, attributes: getAttributes(t)}})
    // }
  }
}

export default XandrInterface

const QueryAPI = function (targetInfo, useMock) {
  if (useMock) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let r = queries[currentEntry]
        currentEntry = currentEntry === queries.length ? 0 : currentEntry + 1
        resolve(r)
      }, 2000)
    })
  } else {
    return XandrAPI.getQueryCount({
      targetDefinition: targetInfo.targetDefinition,
      user: targetInfo.user,
      type: targetInfo.xandrType,
      caeId: targetInfo.caeId,
      audienceExpansion: targetInfo.audienceExpansion,
    }).catch(err => {
      Toast.error({
        title: 'Errored when Querying Segmentation',
        message: 'An error occurred when querying Segmentation',
        timeout: 8000,
      })
      throw err
    })
  }
}

const defaultTraitValues = {
  queryId: 'xxx',
  counts: {
    isUsingMockData: true,
    household: 236146,
    devices: 234712,
    persons: 951280,
    granularDevices: [
      { idType: 'AnchorHHID', count: 28921442 },
      { idType: 'AAID', count: 152171 },
      { idType: 'IDFA', count: 225544 },
      { idType: 'KRUXID', count: 187810 },
      { idType: 'CTV', count: 218562 },
      { idType: 'WMUKID', count: 3871610 },
      { idType: 'BOLTID', count: 2982226 },
    ],
  },
}

let currentEntry = 0

const c = num => {
  let q = cloneDeep(defaultTraitValues)
  return q
}

const queries = [c(7), c(4), c(6), c(9), c(8), c(3), c(5), c(2), c(1)]



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/Xandr/XandrInterface.js